const store = {
    namespaced: true,
    state() {
        return {
            testimonails: []
        }
    },
    getters: {
        getTestimonials(state) {
            return state.testimonails
        }
    },
    mutations: {
        setTestimonials(state, testimonials) {
            state.testimonails = testimonials
        }
    },
}

export default store